<template>
  <div class="page-parent about">

    <section class="about-logo">
      <div class="about-mission-img">
        <img :src="logoAwesomeImg" alt="logo image">
      </div>
    </section>

    <section class="about-mission-bg">
      <div class="about-mission-text card-wide card-shade">
        <h1>{{ $t('about-page.our-mission-title') }}</h1>
        <p style="white-space: pre-line">{{ $t('about-page.our-mission-text') }} </p>

        <h1>{{ $t('about-page.story-so-far-title') }}</h1>
        <p style="white-space: pre-line">{{ $t('about-page.story-so-far-text') }}</p>
      </div>
    </section>

    <div class="wrapper-bg-poly">
      <!-- TODO: decide if we keep it. If we do make translation -->
      <section class="about-facts-container">

        <AboutFacts
          title="Established"
          value="10Y"
          text="Years Ago"
        />
        <AboutFacts
          title="Users"
          value="3m"
          text="So Far"
        />
        <AboutFacts
          title="Peak Bandwidth"
          value="300Gb"
          text="Every Second"
        />
        <AboutFacts
          title="Links Pasted"
          value="200K"
          text="Every Day"
        />

      </section>

      <section class="about-social-bg card-wide card-shade">
        <div class="about-social-text">
          <h1>{{ $t('about-page.community-title') }}</h1>
          <p v-html="$t('about-page.community-text')"></p>
          <div class="about-social-icons ">
            <a href="https://www.facebook.com/seedrcc/">
              <img :src="smFbColorImg" alt="facebook image">
            </a>
            <a href="https://twitter.com/seedrcoil">
              <img :src="smTwitColorImg" alt="twitter image">
            </a>
            <a href="https://www.instagram.com/seedrcc/">
              <img :src="smInstaColorImg" alt="instagram image">
            </a>
            <a href="/">
              <img :src="smYtColorImg" alt="youtube image">
            </a>
            <a href="/">
              <img :src="smLinkedColorImg" alt="linkedin image">
            </a>
          </div>
        </div>
      </section>

      <section class="about-card-bg">

<!--        <div class="about-card card-wide card-shade">-->
<!--          <h1>{{ $t('about-page.part-of-journey-title') }}</h1>-->
<!--          <h2>{{ $t('about-page.see-available-title') }} <a class="link-b" href="/carrers">{{ $t('about-page.careers-link') }}</a></h2>-->
<!--        </div>-->

        <div class="about-card card-wide card-shade">
          <h1>{{ $t('about-page.improvement-idea-title') }}</h1>
          <h2>{{ $t('about-page.send-us-title') }} <a class="link-b" href="https://help.seedr.cc/hc/en-us/requests/new">{{ $t('about-page.feedback-link') }}</a></h2>
        </div>

      </section>

      <section class="about-link">
        <div class="about-link-bg bg-shade">
          <div class="about-link-cards">
            <!-- TODO : once you have text for cards make translation            -->
            <CardBase2
              class="about-card-base"
              :linkName="$t('about-page.products-title')"
              btn="button-secondary"
              :msg="$t('about-page.products-title')"
              cardText="With seedr.cc, you can stream your files smoothly without frustrating buffering delays. Our servers do the heavy lifting so you can focus on enjoying your content. Read more about our products & features"
              btnLink="/#home-products"
            />

<!--            <CardBase2-->
<!--              class="about-card-base"-->
<!--              :linkName="$t('about-page.subscribe-title')"-->
<!--              btn="button-secondary"-->
<!--              :msg="$t('about-page.subscribe-title')"-->
<!--              cardText="Lorem ipsum dolor sit ametmylaoreeuam erat volutpat. Ut wisi enim ad rem ipsum dolor sit amet, aoreet erat volutpat. Ut wisi enrem ipsum dolor sit amet, aoreet erat volutpat. Ut wisi en"-->
<!--              btnLink="/subscribe"-->
<!--            />-->

            <CardBase2
              class="about-card-base"
              :linkName="$t('about-page.pricing-title')"
              btn="button-secondary"
              :msg="$t('about-page.pricing-title')"
              cardText="We offer competitive and affordable pricing tailored to your needs. With packages starting at just $6.95 a month, you unlock the full power of our platform. We also offer annual subscriptions for greater savings.

"
              btnLink="/#home-section-2"
            />

          </div>
        </div>
      </section>

    </div>
  </div>
</template>

<script>

import CardBase2 from '/components/CardBase2.vue'
import AboutFacts from '/components/AboutFacts.vue'

import logoAwesomeImg from '/assets/images/Logo_Awesome_SVG.svg?url'
import smFbColorImg from '/assets/images/SM_FB_Color_SVG.svg?url'
import smTwitColorImg from '/assets/images/SM_Twit_Color_SVG.svg?url'
import smInstaColorImg from '/assets/images/SM_Insta_Color_SVG.svg?url'
import smYtColorImg from '/assets/images/SM_YT_Color_SVG.svg?url'
import smLinkedColorImg from '/assets/images/SM_Linked_Color_SVG.svg?url'

export default {
  name: 'about',
  components: {
    CardBase2,
    AboutFacts
  },
  props: {},
  data() {
    return {
      logoAwesomeImg: logoAwesomeImg,
      smFbColorImg: smFbColorImg,
      smTwitColorImg: smTwitColorImg,
      smInstaColorImg: smInstaColorImg,
      smYtColorImg: smYtColorImg,
      smLinkedColorImg: smLinkedColorImg
    }
  }
}

</script>
